"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ApiData_1 = __importDefault(require("@/api/class/ApiData"));
const analysisApi = {
    homeTop: new ApiData_1.default({
        name: '首页头部分析数据',
        url: 'web/index/indexTopCount',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    homeDealerList: new ApiData_1.default({
        name: '重点经销商排行',
        url: 'web/index/indexDealerList',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'get',
        data: ['inherit']
    }),
    homeKeepCountList: new ApiData_1.default({
        name: '车辆收回排行',
        url: 'web/index/indexKeepCountList',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    homeHandleCountList: new ApiData_1.default({
        name: '车辆处置排行',
        url: 'web/index/indexHandleCountList',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    homeCollectionCountList: new ApiData_1.default({
        name: '催收回款排行',
        url: 'web/index/indexCollectionCountList',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    homeTodo: new ApiData_1.default({
        name: '待办列表',
        url: 'web/index/indexTodoList',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    flowTodo: new ApiData_1.default({
        name: '流程待办',
        url: 'web/index/myTodoList',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
    flowDone: new ApiData_1.default({
        name: '流程已办',
        url: 'web/index/myFinishList',
        urlConfig: {
            pre: '',
            service: 'ufo/cs/'
        },
        method: 'post',
        data: ['inherit']
    }),
};
exports.default = analysisApi;
